<template>
    <!-- TW Snippet Start v2.0+ -->
    <span class="relative z-0 inline-flex shadow-sm rounded-md w-full">
        <button @click="$emit('update:modelValue', 0)" :disabled="disabled" type="button" :class="modelValue === 0 ? 'bg-blue-100' : 'hover:bg-gray-50'" class="justify-center w-1/3 relative inline-flex items-center px-4 py-2 rounded-l-md border border-gray-300 bg-white text-sm font-medium text-gray-700 focus:z-10 focus:outline-none focus:ring-1">
            Základní
        </button>
        <button @click="$emit('update:modelValue', 4)" :disabled="disabled" type="button" :class="modelValue === 4 ? 'bg-blue-100' : 'hover:bg-gray-50'" class="justify-center w-1/3 -ml-px relative inline-flex items-center px-4 py-2 border border-gray-300 bg-white text-sm font-medium text-gray-700 focus:z-10 focus:outline-none focus:ring-1">
            Mobilní klíč
        </button>
        <button @click="$emit('update:modelValue', 2)" :disabled="disabled" type="button" :class="modelValue === 2 ? 'bg-blue-100' : 'hover:bg-gray-50'" class="justify-center w-1/3 -ml-px relative inline-flex items-center px-4 py-2 rounded-r-md border border-gray-300 bg-white text-sm font-medium text-gray-700 focus:z-10 focus:outline-none focus:ring-1">
            Certifikát
        </button>
    </span>
</template>

<script>
export default {
    name: "MethodSelector",

    props: ['modelValue', 'disabled'],

    emits: ['update:modelValue'],
}
</script>

<style scoped>

</style>
